import React, { Component } from 'react';
import { connect } from 'react-redux';
import { localize } from 'react-localize-redux';

import { reduxForm, Field, formValueSelector } from 'redux-form';
import { compose } from 'redux';

import TextField from 'helpers/reduxFormMaterialUiNext/TextField';
import OutlinedSelect from 'helpers/reduxFormMaterialUiNext/OutlinedSelect';

import SearchableSelectRedux from 'components/shared/SearchableSelectRedux';
import { requestDropdown } from 'components/shared/maintenanceDropdownValues';
import RenderDropzoneMultiFileInput from 'components/shared/RenderDropzoneMultiFileInput';
import RecurringFields from 'components/shared/RecurringFields';
import TenantResidentVerbiageHelper from 'components/shared/TenantResidentVerbiageHelper';

import { getSuiteRooms } from 'helpers/SelectOptions';
import * as validator from 'helpers/Validator';
import { RenderIfToggleOn } from 'components/shared/ToggleRenderer';

import MenuItem from 'material-ui/MenuItem';

import { getProperties, getUnits, showUnits } from 'actions/landlordPropertiesActions';
import { getListOfMaintenanceStaff, getAssets } from 'actions/maintenanceActions';
import TicketAssignmentForm from './TicketAssignmentForm';
import camelCase from 'lodash/camelCase';
import { getTranslatedString } from 'helpers/i18n';
import { featureEnabled } from 'helpers/ToggleBot';

let AddMaintenanceTicketForm = class AddMaintenanceTicketForm extends Component {
  getUnitsAndMaintenance = (selectedProperty) => {
    this.props.getListOfMaintenanceStaff(selectedProperty.value);
    this.props.getUnits(selectedProperty.value, { for_multiselect: true });
    this.props.getAssets({
      property_id: selectedProperty.value,
      for_multiselect: true,
    });
  };

  getUnitAssets = (selectedUnit) => {
    if (selectedUnit.value === 'None') return;

    this.props.getAssets({
      unit_id: selectedUnit.value,
      for_multiselect: true,
    });
  };

  getPropertyType = () => {
    const { selectedProperty, properties } = this.props;
    if (!selectedProperty) return null;

    const propertyHash = properties.find((property) => property.value === selectedProperty.value);
    return propertyHash && propertyHash.property_type;
  };

  getMaintenanceTicketCategories = () => {
    const { selectedProperty, selectedUnit, maintenanceCategories } = this.props;

    if (selectedProperty && selectedUnit) {
      return maintenanceCategories.filter((category) =>
        ['suite', 'all_locations'].includes(category.location)
      );
    }

    return maintenanceCategories.filter((category) =>
      ['common_area', 'all_locations'].includes(category.location)
    );
  };

  render() {
    const { translate } = this.props;
    const FILE_FIELD_NAME = 'files';

    const style = {
      receipt_header: {
        margin: '0 0 10px 0',
        backgroundColor: '#f1f1f1',
        padding: '5px 10px',
        fontSize: '14px',
        fontWeight: '800',
        borderRadius: '3px',
      },
    };

    return (
      <form autoComplete="off">
        <div className="row">
          <div className="row" style={style.receipt_header}>
            <div className="col-xs-12">
              <p style={{ margin: '0', textAlign: 'center' }}>
                {' '}
                {translate('landlordPortal.addMaintenanceTicketForm.locationUpcase')}{' '}
              </p>
            </div>
          </div>
          <div
            className="row"
            style={{
              marginBottom: '20px',
              marginTop: '-20px',
              padding: '0 15px',
            }}
          >
            <TicketAssignmentForm formName={this.props.form} />
          </div>

          {this.props.showRecurrance && (
            <div className="row" style={{ padding: '0' }}>
              <div className="row" style={style.receipt_header}>
                <div className="col-xs-12">
                  <p style={{ margin: '0', textAlign: 'center' }}>
                    {' '}
                    {translate(
                      'landlordPortal.addMaintenanceTicketForm.templateDetailsUpcase'
                    )}{' '}
                  </p>
                </div>
              </div>
              <div style={{ padding: '0 15px' }}>
                <RecurringFields formName={this.props.formName} />
              </div>
            </div>
          )}
          <div className="row" style={style.receipt_header}>
            <div className="col-xs-12">
              <p style={{ margin: '0', textAlign: 'center' }}>
                {' '}
                {translate('landlordPortal.addMaintenanceTicketForm.ticketDetailsUpcase')}{' '}
              </p>
            </div>
          </div>

          <div className="row" style={{ padding: '0 15px' }}>
            <div className="col-sm-12" style={{ marginTop: '15px' }}>
              <Field
                name="subject"
                validate={[validator.required]}
                component={TextField}
                fullWidth
                style={{ fontSize: '15px' }}
                variant="outlined"
                label={translate('RFM.subject')}
              />
            </div>
            <div className="col-sm-12" style={{ marginTop: '15px' }}>
              <Field
                name="ticket_description"
                component={TextField}
                validate={[validator.required]}
                label={translate('RFM.description')}
                multiline
                fullWidth
                rows={2}
                style={{ fontSize: '15px' }}
                variant="outlined"
              />
            </div>
            <div className="col-sm-12" style={{ marginTop: '15px' }}>
              <Field
                name="category"
                component={OutlinedSelect}
                validate={[validator.required]}
                fullWidth
                autoWidth
                variant="outlined"
                label={translate('RFM.category')}
              >
                {this.getMaintenanceTicketCategories().map((category) => (
                  <MenuItem value={category.value} key={category.label}>
                    {category.label}
                  </MenuItem>
                ))}
              </Field>
            </div>
            <div className="col-sm-6" style={{ marginTop: '15px' }}>
              <Field
                name="request_type"
                component={OutlinedSelect}
                validate={[validator.required]}
                fullWidth
                autoWidth
                variant="outlined"
                label={translate('RFM.request_type')}
              >
                {requestDropdown.map((requestType) => {
                  return (
                    <MenuItem
                      value={requestType}
                      disabled={[
                        'Preventative Maintenance',
                        'Portal Request - Maintenance',
                        'Portal Request - Other',
                        'Kiosk Request',
                      ].includes(requestType)}
                    >
                      {translate(
                        `landlordPortal.addMaintenanceTicketForm.${camelCase(requestType)}`
                      )}
                    </MenuItem>
                  );
                })}
              </Field>
            </div>
            <div className="col-sm-6" style={{ marginTop: '15px' }}>
              <Field
                name="priority"
                component={OutlinedSelect}
                validate={[validator.required]}
                fullWidth
                autoWidth
                variant="outlined"
                label={translate('RFM.priority')}
              >
                <MenuItem value={'Emergency'}> {translate('RFM.emergency')} </MenuItem>
                <MenuItem value={'High'}> {translate('RFM.high')} </MenuItem>
                <MenuItem value={'Normal'}> {translate('RFM.normal')} </MenuItem>
              </Field>
            </div>
            <RenderIfToggleOn toggle="ui.create_service_request.permission_to_enter">
              <div className="col-sm-6" style={{ marginTop: '15px' }}>
                <Field
                  name="permission_to_enter"
                  component={OutlinedSelect}
                  fullWidth
                  autoWidth
                  validate={[validator.required]}
                  variant="outlined"
                  label={translate('RFM.permission_to_enter')}
                >
                  <MenuItem value={true} key={0}>
                    {translate('request_type.yes')}
                  </MenuItem>
                  <MenuItem value={false} key={1}>
                    {translate('request_type.no')}
                  </MenuItem>
                </Field>
              </div>
            </RenderIfToggleOn>
            <RenderIfToggleOn toggle="ui.create_service_request.consent_to_entry_while_away">
              <div className="col-sm-6" style={{ marginTop: '15px' }}>
                <Field
                  name="consent_to_entry_while_away"
                  component={OutlinedSelect}
                  fullWidth
                  autoWidth
                  validate={[validator.required]}
                  variant="outlined"
                  label={translate('landlordPortal.serviceRequest.consentToEntryWhileAway')}
                >
                  <MenuItem value={true} key={0}>
                    {translate('request_type.yes')}
                  </MenuItem>
                  <MenuItem value={false} key={1}>
                    {translate('request_type.no')}
                  </MenuItem>
                </Field>
              </div>
            </RenderIfToggleOn>
            <div className="col-sm-6" style={{ marginTop: '15px' }}>
              <Field
                name="suite_location"
                component={OutlinedSelect}
                validate={[validator.required]}
                fullWidth
                autoWidth
                variant="outlined"
                label={translate('RFM.suite_location')}
              >
                {this.renderSuiteLocations()}
              </Field>
            </div>
            <div className="col-sm-6" style={{ marginTop: '15px' }}>
              <Field
                name="assign"
                component={SearchableSelectRedux}
                filter={(searchText, key) => key.indexOf(searchText) !== -1}
                fullWidth
                grouped
                options={this.props.maintenanceStaff}
                placeholder={translate('landlordPortal.addMaintenanceTicketForm.assignedTo')}
                variant="outlined"
              />
            </div>
            <div className="col-sm-12" style={{ marginTop: '15px' }}>
              <Field
                name="hide_from_tenant"
                component={OutlinedSelect}
                label={translate('doNotDisplayToTenant')}
                fullWidth
                autoWidth
                validate={[validator.required]}
              >
                <MenuItem value={true} key={0}>
                  {translate('request_type.yes')}
                </MenuItem>
                <MenuItem value={false} key={1}>
                  {translate('request_type.no')}
                </MenuItem>
              </Field>
            </div>
            <RenderIfToggleOn toggle="ui.maintenance.show_external_po_number_field">
              <div className="col-xs-12" style={{ marginTop: '15px' }}>
                <Field
                  name="external_po_number"
                  component={TextField}
                  hintStyle={{ fontSize: '15px' }}
                  rows={1}
                  multiline
                  fullWidth
                  variant="outlined"
                  label={getTranslatedString(
                    'landlordPortal.addMaintenanceTicketForm.externalPoNumber'
                  )}
                />
              </div>
            </RenderIfToggleOn>

            <div className="col-xs-12" style={{ marginTop: '15px' }}>
              <Field
                name="internal_notes"
                component={TextField}
                hintText={
                  <span>
                    <TenantResidentVerbiageHelper capitalize />
                    {translate('landlordPortal.addMaintenanceTicketForm.willNotSee')}
                  </span>
                }
                hintStyle={{ fontSize: '15px' }}
                rows={2}
                multiline
                fullWidth
                variant="outlined"
                label={
                  translate('landlordPortal.addMaintenanceTicketForm.internalNotes').props.children
                }
              />
            </div>
            <div className="col-xs-12" style={{ margin: '15px 0' }}>
              <Field
                name="notes_to_tenant"
                component={TextField}
                hintText={
                  <span>
                    {translate('landlordPortal.addMaintenanceTicketForm.optionally')}{' '}
                    <TenantResidentVerbiageHelper capitalize />
                    {translate('landlordPortal.addMaintenanceTicketForm.withExtraDetails')}
                  </span>
                }
                hintStyle={{ fontSize: '15px' }}
                rows={2}
                multiline
                fullWidth
                variant="outlined"
                label={
                  <span>
                    <TenantResidentVerbiageHelper
                      translatedTenant={translate(
                        'landlordPortal.addMaintenanceTicketForm.notesToTenant'
                      )}
                      translatedResident={translate(
                        'landlordPortal.addMaintenanceTicketForm.notesToResident'
                      )}
                    />
                  </span>
                }
              />
            </div>
          </div>

          <div className="row" style={style.receipt_header}>
            <div className="col-xs-12">
              <p style={{ margin: '0', textAlign: 'center' }}>
                {' '}
                {translate('landlordPortal.addMaintenanceTicketForm.photoUpcase')}{' '}
              </p>
            </div>
          </div>

          <div className="row" style={{ padding: '15px' }}>
            <Field
              name={FILE_FIELD_NAME}
              component={RenderDropzoneMultiFileInput}
              multiple={false}
              acceptedFileTypes=".jpeg, .png, .jpg, application/pdf"
            />
          </div>
        </div>
      </form>
    );
  }

  renderSuiteLocations = () => {
    const { selectedProperty, selectedUnit, maintenanceLocations, translate } = this.props;

    if (!featureEnabled('maintenance.dynamic_locations')) {
      return getSuiteRooms(selectedUnit, this.getPropertyType()).map((room) => (
        <MenuItem value={room.value} key={translate(room.label)}>
          {translate(room.label)}
        </MenuItem>
      ));
    }

    if (selectedProperty && selectedUnit) {
      return maintenanceLocations
        .filter((location) => ['suite', 'all_locations'].includes(location.ticket_location))
        .map((room) => (
          <MenuItem value={room.value} key={room.label}>
            {room.label}
          </MenuItem>
        ));
    }

    return maintenanceLocations
      .filter((location) => ['common_area', 'all_locations'].includes(location.ticket_location))
      .map((room) => (
        <MenuItem value={room.value} key={room.label}>
          {room.label}
        </MenuItem>
      ));
  };
};

const mapStateToProps = (store, ownProps) => {
  return {
    form: ownProps.formName,
    properties: store.landlordProperties.properties,
    units: store.landlordProperties.units,
    maintenanceAssets: store.maintenanceReducer.maintenanceAssets,
    unitActiveLease: store.landlordProperties.unitActiveLease,
    maintenanceStaff: store.maintenanceReducer.maintenance,
    selectedUnit: formValueSelector(ownProps.formName)(store, 'unit'),
    selectedProperty: formValueSelector(ownProps.formName)(store, 'property'),
    maintenanceCategories: store.maintenanceReducer.maintenanceCategories,
    maintenanceLocations: store.maintenanceReducer.maintenanceLocations,
  };
};

export default compose(
  connect(mapStateToProps, {
    getUnits,
    getProperties,
    showUnits,
    getListOfMaintenanceStaff,
    getAssets,
  }),
  reduxForm({
    destroyOnUnmount: true,
  })
)(localize()(AddMaintenanceTicketForm));
